import {createAction} from "@reduxjs/toolkit";

export const pushGalleryPage = createAction('PUSH_GALLERY_PAGE');